import { updateProductProperties } from '../gql/mutation'
import getNameOfGqlQuery from 'helpers/getNameOfGqlQuery'

export default ({ productId, ...restVals }, mutationFunc) => {
	if(!productId) {
		throw new Error('Can not update field "properties" in "Product". Variable "productId" was not provided.')
	}
	const mutationName = getNameOfGqlQuery(updateProductProperties)
	mutationFunc({
		variables: {
			productId,
			fields: restVals
		},
		optimisticResponse: {
			__typename: 'Mutation',
			[mutationName]: {
				__typename: 'Product',
				id: productId,
				mod_ver: -1,
				properties: { ...restVals, __typename: 'ProductProperties' }
			}
		}
	})
}
